import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { LogConfig, LogEntry } from './log-service.types';


@Injectable({
  providedIn: 'root'
})

export class LogService {
  appInsights: ApplicationInsights;
  logs: LogEntry[] = [];

  constructor(
    @Inject('LogConfig') private logConfig: LogConfig,
    private http: HttpClient, private router: Router) {
    this.appInsights = new ApplicationInsights({
      config: {
        instrumentationKey: logConfig.instrumentationKey,
        enableAutoRouteTracking: false,
        enableResponseHeaderTracking: false,
        enableAjaxErrorStatusText: true,
        enableAjaxPerfTracking: true,
        
      }
    });
    this.appInsights.loadAppInsights();
    this.appInsights.trackPageView();
    this.loadCustomTelemetryProperties();
  }

  setUserId(userId: string) {
    const cleanUserId = userId.replace(/\s/g, '') // Cannot contain white space
    this.appInsights.setAuthenticatedUserContext(cleanUserId);
  }

  clearUserId() {
    this.appInsights.clearAuthenticatedUserContext();
  }

  logPageView(name?: string, url?: string) { // option to call manually
    this.appInsights.trackPageView({
      name: name,
      uri: url
    });
  }

  logEvent(name: string, properties?: { [key: string]: any }) {
    this.appInsights.trackEvent({ name: name }, properties);
  }

  logMetric(name: string, average: number, properties?: { [key: string]: any }) {
    this.appInsights.trackMetric({ name: name, average: average }, properties);
  }

  logException(exception: Error, severityLevel?: number) {
    this.appInsights.trackException({ exception: exception, severityLevel: severityLevel });
  }

  logTrace(message: string, properties?: { [key: string]: any }) {
    this.appInsights.trackTrace({ message: message }, properties);
  }

  private loadCustomTelemetryProperties() {
    this.appInsights.addTelemetryInitializer(envelope => {
      const item = envelope.baseData;
      if (item) {
        item['properties'] = item['properties'] || {};
        item['properties']["AppName"] = this.logConfig.appName;
      }
    }
    );
  }
}